import { useCallback } from "react";
import { useMISReportDownload } from "@hooks/useMISReportDownload";
import { MIS_FIELDS_ACTIVEJOURNEY } from "@constants/misDownloadData";
import { ATP_API_URL } from "@config/apiconfig";

export const useActiveJourneyDownload = () => {
  const dataMapper = useCallback(
    (item) => ({
      "SR. No ": item.srNo,
      PNR: item.pnr,
      "Train No": item.trainNo || "-",
      "Travel Date": item.travelDate
        ? new Date(item.travelDate).toLocaleDateString()
        : "-",
      "Chart Preparation Time": item.chartPreparationTime
        ? new Date(item.chartPreparationTime).toLocaleDateString()
        : "-",
      "Final Waitlist Status": item.finalWaitlistStatus || "-",
      "Final Probability (%)": item.finalProbability || "-",
      "Product Active (Y/N)": item.productActive || "-",
      "Expected Claim Amount (₹)": item.expectedClaimAmount || "-",
    }),
    [],
  );

  return useMISReportDownload({
    reportType: "active-journey",
    reportName: "Active Journey",
    fields: MIS_FIELDS_ACTIVEJOURNEY,
    dataMapper,
    apiUrl: ATP_API_URL.MIS_ACTIVE_JOURNEY,
    sheetName: "Active Journey",
  });
};

export default useActiveJourneyDownload;
